import { z } from "zod";
const _BeatSubDivisionOptions = [1, 2, 4, 8];
const _RecordingCountInBars = [1, 2, 3, 4, 5, 6, 7, 8];
const _OlderTakeActionOptions = ["disable-track", "mute-region"];
const _OlderTakeScopeOptions = ["none", "all", "previous-only"];
export const EngineSettingsSchema = z.object({
    metronome: z.object({
        enabled: z.boolean(),
        beatSubDivision: z.union(_BeatSubDivisionOptions.map(value => z.literal(value))),
        gain: z.number().min(Number.NEGATIVE_INFINITY).max(0),
        monophonic: z.boolean()
    }).default({
        enabled: false,
        beatSubDivision: 1,
        gain: -6.0,
        monophonic: true
    }),
    playback: z.object({
        timestampEnabled: z.boolean(),
        pauseOnLoopDisabled: z.boolean(),
        truncateNotesAtRegionEnd: z.boolean()
    }).default({
        timestampEnabled: true,
        pauseOnLoopDisabled: false,
        truncateNotesAtRegionEnd: false
    }),
    debug: z.object({
        dspLoadMeasurement: z.boolean()
    }).default({
        dspLoadMeasurement: false
    }),
    recording: z.object({
        countInBars: z.union(_RecordingCountInBars.map(value => z.literal(value))),
        allowTakes: z.boolean(),
        automationEnabled: z.boolean(),
        olderTakeAction: z.union(_OlderTakeActionOptions.map(value => z.literal(value))),
        olderTakeScope: z.union(_OlderTakeScopeOptions.map(value => z.literal(value))),
        inputLatency: z.number().min(-1)
    }).default({
        countInBars: 1,
        allowTakes: true,
        automationEnabled: true,
        olderTakeAction: "mute-region",
        olderTakeScope: "previous-only",
        inputLatency: 0
    })
});
export var EngineSettings;
(function (EngineSettings) {
    EngineSettings.BeatSubDivisionOptions = _BeatSubDivisionOptions;
    EngineSettings.RecordingCountInBars = _RecordingCountInBars;
    EngineSettings.OlderTakeActionOptions = _OlderTakeActionOptions;
    EngineSettings.OlderTakeScopeOptions = _OlderTakeScopeOptions;
})(EngineSettings || (EngineSettings = {}));
